import {
  applyFormula,
  isFormula,
  isToddleFormula,
} from '@nordcraft/core/src/formula/formula'
;(window as any).editorFormula = { applyFormula, isFormula, isToddleFormula }
// Explicitly import from src (not dist/) to target typescript (non transpiled) files
